var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3328 2.66699L11.3327 12.9737M13.9995 10.667L11.3327 13.3337L8.66602 10.667",
    stroke: "#1E201C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66655 13.3336L4.66651 2.88175M2 5.33362L4.66651 2.66699L7.33333 5.33376",
    stroke: "#1E201C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortIcon);
export default __webpack_public_path__ + "static/media/sort-icon.c8eb7abd0a68a24f16eadd44ac46184b.svg";
export { ForwardRef as ReactComponent };